﻿import React, { useEffect, useState } from "react";
import NavGroup from "./NavGroup";

interface NavOptionProps {
    LinkText: string;
    LinkUrl: string;
    IconUrl: string;
    IconOnly: boolean;
    NavGroups: NavGroup[];
    IsActive: boolean;
    handleActivation: (urlKey: string) => void;
    IsMobile: boolean;
}

const NavOption = (props:NavOptionProps) => {
    
    const [navGroups, setNavGroups] = useState<NavGroup[]>(props.NavGroups);
    
    const buildText = () => {
        if(!props.IconUrl) {
            return props.LinkText
        } else {
            if(props.IconOnly && !props.IsMobile) {
                return (
                    <img 
                        src={props.IconUrl} 
                        alt={props.LinkText}
                    />
                )
            }
            
            return <><img src={props.IconUrl} alt={props.LinkText} /><span>{props.LinkText}</span></>
        }
    }
    
    useEffect(() => {
        
        if(props.NavGroups != null && props.NavGroups.length > 0 && props.IsMobile)
        {
            let allNavLink:NavLink =  {
                LinkText: "All",
                LinkUrl: props.LinkUrl,
                LinkOrder: 0,
                NewWindow: false,
                IconUrl: "",
                Enabled: true,
                Bold: true
            }
            
            let allGroup:NavGroup = {
                GroupName: "All",
                NavLinks: [allNavLink],
                GroupOrder: 0
            }

            console.log("outputting navgroups")
            console.log(props.NavGroups);
            setNavGroups([allGroup,...props.NavGroups])
            console.log("Mobile data", allGroup)
        }
        
        
    }, [props.IsMobile, props.NavGroups])

    if(props.IsMobile)
    {
        return (
            <li
                className={`nav_option ${props.IsActive ? 'active' : ''}`}
                onClick={() => props.handleActivation(props.LinkUrl)}
            >
                {(props.NavGroups == null || props.NavGroups.length === 0) &&
                <a
                    href={props.LinkUrl}
                >
                    {buildText()}
                </a>}

                {props.NavGroups != null && props.NavGroups.length > 0 &&
                    <a
                        href="#"
                        onClick={(e) => {e.preventDefault();}}
                    >
                        {buildText()}
                    </a>
                }

                {
                    navGroups != null && navGroups.length > 0 ?
                        <div className={`mobile_submenu ${props.IsActive ? 'active' : ''}`}>
                            <div className={"submenu_content"}>
                                {navGroups
                                    .sort((a, b) => a.GroupOrder - b.GroupOrder)
                                    .map((group) => {
                                        return (<NavGroup
                                            key={group.GroupName + "group"}
                                            GroupName={group.GroupName}
                                            NavLinks={group.NavLinks}
                                        />)
                                    })}
                            </div>
                        </div>: null
                }
            </li>
        )
    } 
    else {
        return (
            <li
                className={`nav_option ${props.IsActive ? 'active' : ''}`}
                onMouseOver={() => props.handleActivation(props.LinkUrl)}
                onMouseLeave={() => props.handleActivation("")}
            >
                {props.LinkUrl.startsWith("http") && 
                <a
                    href={props.LinkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-tooltip-content={props.IconUrl ? props.LinkText : null}
                    data-tooltip-id={props.IconUrl ? "menu-tooltip" : null}
                >
                    {buildText()}
                </a>}

                {props.LinkUrl.startsWith("/") &&
                    <a
                        href={props.LinkUrl}
                        data-tooltip-content={props.IconUrl ? props.LinkText : null}
                        data-tooltip-id={props.IconUrl ? "menu-tooltip" : null}
                    >
                        {buildText()}
                    </a>}

                {props.LinkUrl.startsWith("#") && 
                    <a href={props.LinkUrl}
                       onClick={(e) => {e.preventDefault();}}
                       data-tooltip-content={props.IconUrl ? props.LinkText : null}
                       data-tooltip-id={props.IconUrl ? "menu-tooltip" : null}
                       className={"unclickable"}
                        >
                    {buildText()}
                    </a>
                }

                {
                    props.NavGroups != null && props.NavGroups.length > 0 ?
                        <div className={`submenu ${props.IsActive ? 'active' : ''}`}>
                            <div className={"submenu_content"}>
                                {props.NavGroups
                                    .sort((a, b) => a.GroupOrder - b.GroupOrder)
                                    .map((group) => {
                                        return (<NavGroup
                                            key={group.GroupName}
                                            GroupName={group.GroupName}
                                            NavLinks={group.NavLinks}
                                        />)
                                    })}
                            </div>
                        </div>: null
                }
            </li>
        )
    }
    
}

export default NavOption